import request from '@/router/axios';

const getList = (current, size, params) => request({
  // url: '/api/mcc-worker/infocert/page',
  url: '/api/mcc-worker/infocert/fileLists',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const getFileUrl = params => request({
  url: '/api/mcc-worker/infocert/getUrl',
  method: 'get',
  params,
})

const submit = params => request({
  url: '/api/mcc-worker/infocert/save',
  method: 'post',
  data: params,
})

const update = params => request({
  // url: '/api/mcc-worker/infocert/update',
  url: '/api/mcc-worker/infocert/updateCert',
  method: 'post',
  data: params,
})

const uploadCertificate = params => {
  const formData = new FormData()
  Object.entries(params).forEach(el => {
    formData.append(el[0], el[1])
  })
  return request({
    url: '/api/mcc-worker/infocert/upload',
    method: 'post',
    data: formData,
  })
}

const remove = ids => request({
  url: '/api/mcc-worker/infocert/remove',
  method: 'post',
  params: {
    ids,
  },
})

export default {
  getList,
  update,
  submit,
  remove,
  getFileUrl,
  uploadCertificate,
}
